export { default as NikoFacilityListTemplate } from './NikoFacilityListTemplate'; 